import React from 'react';
import { Box, InlineNotification, Loading } from '@cko/primitives';
import { IconActionCheckSmall, IconActionCross } from '@cko/icons';
import { FileStatus } from '../../types';
import Row from './Row';
import RowIcon from './RowIcon';
import DeleteButton from './DeleteButton';
export const DroppedRow = ({ id, name, status, errors, children, handleDelete }) => {
    function getIcon() {
        switch (status) {
            case FileStatus.Success:
            case FileStatus.Idle:
                return React.createElement(IconActionCheckSmall, { "data-testid": "file-success" });
            case FileStatus.Error:
                return React.createElement(IconActionCross, { "data-testid": "file-error" });
            default:
                return (React.createElement(Box, { py: "var(--layout-seed)", "data-testid": "file-loading" },
                    React.createElement(Loading, { width: "32px" })));
        }
    }
    const getErrors = () => {
        if (errors) {
            return errors.map((error) => (React.createElement(InlineNotification, { key: error, type: "alert", withIcon: true }, error)));
        }
        return null;
    };
    const onDelete = () => {
        handleDelete(id, status === FileStatus.Success || status === FileStatus.Idle);
    };
    if (status === FileStatus.Loading) {
        return (React.createElement(Row, { "data-testid": "file-loading-row" },
            React.createElement(RowIcon, { icon: getIcon(), description: name }),
            React.createElement(Box, { my: "auto", style: { flexGrow: 1 } })));
    }
    return (React.createElement(Row, null,
        React.createElement(RowIcon, { icon: getIcon(), description: name }),
        React.createElement(Box, { my: "auto", style: { flexGrow: 1 } }, status === FileStatus.Error ? getErrors() : children({ id })),
        React.createElement(DeleteButton, { name: `${name}-delete`, onDelete: onDelete })));
};
